import client from "./client";

export async function subscribeToOutOfStockNotifications(
    inputs: Record<string, unknown>,
) {
    const response = await client.post("/mail-subscribers", inputs);

    return response.data;
}

export async function subscribeToCampaign(
    subscriberId: number,
    campaignId: number,
) {
    const response = await client.post(
        `/mail-subscribers/${subscriberId}/subscribe/${campaignId}`,
    );

    return response.data;
}

export async function unsubscribeFromCampaign(
    subscriberId: number,
    campaignId: number,
) {
    const response = await client.post(
        `/mail-subscribers/${subscriberId}/unsubscribe/${campaignId}`,
    );

    return response.data;
}
